import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAdmin } from "@/lib/adminAuth";
import { formatApiError } from "@/lib/auth";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { login } = useAdmin();
  const [email, setEmail] = useState("admin@foliosy.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome, admin");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grain-overlay bg-slate-900 text-white flex items-center justify-center p-6">
      <form onSubmit={submit} className="glass rounded-3xl p-10 max-w-md w-full text-slate-900 bg-white/90" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo-mark.png" alt="Foliosy" className="h-10 w-10 object-contain" />
          <div>
            <p className="eyebrow text-slate-500">Platform admin</p>
            <h1 className="text-2xl font-bold tracking-tight">Foliosy HQ</h1>
          </div>
        </div>
        <div className="inline-flex items-center gap-2 bg-slate-900 text-white rounded-full px-3 py-1 text-xs mb-6">
          <ShieldCheck className="w-3.5 h-3.5" /> Super-admin access only
        </div>

        <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 mb-4 focus:bg-white focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 outline-none"
          data-testid="admin-email-input"
        />
        <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 mb-6 focus:bg-white focus:ring-2 focus:ring-slate-900/5 focus:border-slate-900 outline-none"
          data-testid="admin-password-input"
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-slate-900 text-white rounded-full py-3 font-medium hover:bg-slate-700 active:scale-95 disabled:opacity-50"
          data-testid="admin-login-button"
        >
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <p className="mt-6 text-xs text-center text-slate-400">
          <Link to="/" className="underline">← Back to Foliosy</Link>
        </p>
      </form>
    </div>
  );
}
